exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#site-name[data-v-7f3d8c0c] {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  font-size: 1.8em;\r\n  font-weight: 900;\r\n  padding: 16px 0px;\r\n  position: relative\n}\n.navbar-brand[data-v-7f3d8c0c] {\r\n  padding-left: 0;\n}\r\n\r\n", ""]);

// exports
